module.exports = __webpack_public_path__ + "static/media/a6.c3ad9c0.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wangxingxing/a6.mp3
// module id = IZAX
// module chunks = 0